









import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {
  }
})
export default class WebPageDoc extends Vue {
  @Prop() url!: string; // 页面地址
  @Prop() title!: string; // 页面标题
  @Prop() transferData!: any; // 传输数据

  get webPage () {
    const page = () => import(`@/${this.url}`);
    return page;
  }
}
